export default {
  data () {
    return {
      savedItemId: null
    }
  },
  methods: {
    saveNewSuccess (result) {
      this.$bus.$emit('resource-added')

      this.savedItemId = undefined !== result && undefined !== result.inserted_id ? result.inserted_id : null

      this.dialog = false

      this.dialogMessage = 'Successfully added'
      this.dialogOpen = true
    },
    saveNewError (error) {
      let handle = error // eslint-disable-line
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/AddButton.js